import axios from 'axios';
import apisUrls from '../urls';

const getInfluencersSocialApi = (paramsFilter) => {
  return axios.get(apisUrls?.getInfluencerSocials);
};

export default getInfluencersSocialApi;
